import { memo } from "react";
import PropTypes from "prop-types";
import "./Searchbar.scss";
import classNames from "classnames";
import { SearchIcon, CrossIcon } from "app/icons/navigation";

const Searchbar = ({ className, onClear, value, ...props }) => {
	const searchbarClassName = classNames("searchbar-input", className);
	const showClearButton = Boolean(onClear) && value?.length > 0;

	return (
		<div className={searchbarClassName}>
			<SearchIcon width={20} className="searchbar-input__icon" />
			<input type="text" value={value} {...props} />

			{showClearButton && (
				<button type="button" className="searchbar-input__clear" onClick={onClear}>
					<CrossIcon size={16} />
				</button>
			)}
		</div>
	);
};

Searchbar.propTypes = {
	onClear: PropTypes.func,
	value: PropTypes.string,
};

export default memo(Searchbar);
